var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-footer",on:{"click":_vm.toBan}},[_vm._v(" ©2020 bpmchisel.Com All Rights Reserved!京ICP备2021001688号-2 ")])}
var staticRenderFns = []

export { render, staticRenderFns }